import { Component, inject } from '@angular/core';
import { UilabMatButton, UilabMatIconModule } from '@uilab/ng-mat-components';
import { ThemeService } from 'src/app/services/theme/theme.service';

@Component({
    selector: 'avd-theme-toggle-button',
    standalone: true,
    templateUrl: './theme-toggle-button.component.html',
    styleUrls: ['./theme-toggle-button.component.scss'],
    imports: [UilabMatButton, UilabMatIconModule],
})
export class ThemeToggleButtonComponent {
    private readonly themeService = inject(ThemeService);

    toggleTheme(): void {
        this.themeService.switchTheme();
    }

    isDarkThemeEnabled(): boolean {
        return this.themeService.getDocumentTheme() === 'dark';
    }

    getThemeToggleLabel(): string {
        return this.themeService.getThemeToggleLabel();
    }
}
